import {  useEffect, useState, useMemo } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { useGetProductQuery, useReactToProductMutation, useLazyGetProductReactionsQuery, useUpdateDistributorProductMutation } from "context/product/productApiSlice"; // useUpdateProductMutation
import { useSelector } from "react-redux";
import { selectCurrentUser } from "context/auth/authSlice";
import { useMaterialUIController } from "context";
import { motion, AnimatePresence } from "framer-motion";

import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Icon from '@mui/material/Icon';
import SearchIcon from '@mui/icons-material/Search';
import { Grid , IconButton, Divider } from "@mui/material";

import MDBadge from "dashboard/components/MDBadge";
import MDBox from "dashboard/components/MDBox";
import MDAvatar from "dashboard/components/MDAvatar";
import MDTypography from "dashboard/components/MDTypography";
import MDInput from "dashboard/components/MDInput";
import MDPagination from "dashboard/components/MDPagination";
import loader from "assets/images/shapes/loader.svg";

import ProductCard from "components/Home/products/components/ProductCard";
import { TopBarCategorySelect } from "components/Home/products/components/CategorySelect";
import ProductDetails from "components/Home/products/sections/ProductDetails";
import Ratings from "components/Home/products/components/Ratings"

import useAlert from "hooks/useAlert";
import useSearch from "hooks/useSearch";
import { MDDropdown } from "dashboard/examples/Forms/CostumFormFields/SelectMutipple";

import MDAlert from "dashboard/components/MDAlert";
import { useParams } from "react-router-dom";

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexGrow : 1,
  width:"100%",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const size = {xs:6,md:4,lg:3,xl:2.4};



const variant = {
hidden : {opacity : 0},
visible: (index)=>({
  opacity :1,
  transition:{
    delay: .1 * Math.floor(index/3)
  }
})
}

const MotionCard = motion(ProductCard);
let pageCount = 0;
let totalResult = 0;
let details;

const Products = ({ parseContent, distributerId = null }) => {
  const connectedUser = useSelector(selectCurrentUser);
  const [noMoreResults, setNoMoreResults] = useState(false);
  const [reactions, setReactions] = useState([]);
  const [controller ] = useMaterialUIController();
  const { lang } = controller;
  const { category } = useParams();
  const [likeProduct,{ isLoading : reactLoading }] = useReactToProductMutation();
  const [getReactions] =  useLazyGetProductReactionsQuery();
  const [updateProduct, {isLoading : distLoading}] = useUpdateDistributorProductMutation();
  const [productList, setProductList] = useState(null);
  const { showAlerts } = useAlert();
  const { searchTerm, filterSearch, unsetSearch } = useSearch();
  const [selectedId, setSelectedId]  = useState(null)
  const [view, setView] = useState(false);
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);

  const setSelectedProduct = product =>{
    setTimeout(()=>setSelectedId(product),300)
    toggleModal();
  }

  const productsQuery = useMemo(
    () => {
      const filters = Object.fromEntries(Object.entries(searchTerm.filters).filter((item) => item[1] !== null && item[1] !== undefined && item[1] !== '' ));
      if(connectedUser?.isAdmin === "PARTNER") filters.distributor = connectedUser.id;
      return({
      page: searchTerm.page,
      filters: JSON.stringify({...filters, lang, distributerId }),
      productsPerpage: searchTerm.entriesPerpage,
      sortBy:searchTerm.sortBy
     })},
    [searchTerm]
  );

  const {
    data: products = [],
    isLoading,
    isSuccess,
    isFetching,
    isError,
    error,
    
  } = useGetProductQuery(productsQuery, {
      // pollingInterval: 60000,
      refetchOnMountOrArgChange: true,
      skip: noMoreResults
  });

  useEffect(() => {
    if (isSuccess) {
      const { productsDetails, entities, ids } = products;
      const loadedList = Object.values(entities);
      details = productsDetails;
      pageCount = Number(Math.ceil(productsDetails?.total_results / productsDetails?.productsPerpage ));
      totalResult = productsDetails?.total_results;
      setProductList(loadedList.length ? loadedList : null);
      getReactions({ids:JSON.stringify(ids)}).then((response) => {
        // Set the reactions data for each product
        setReactions(response.data);
      }) .catch((error) => {});
    }
  }, [isSuccess, products]);
  
  useEffect(() => {
    if(!products?.length && productsQuery?.page > 1 ) {
      setNoMoreResults(true);
    }

    /* eslint-disable */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  error.data?.error || error.message,
      color :"error"
    }) : null
  }, [isError]);

  useEffect(() => {
    category && filterSearch({filters : { category : decodeURIComponent(category) }});
    return ()=>unsetSearch()
  }, [category]);

  let typingTimeout;

  const handleSearch = event => {
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(()=> {
      filterSearch({ filters : {...searchTerm.filters, [event.target.name] : event.target.value} });
    }, 500);
  }
  const handleLikeProduct = async update =>{
    try{
      /*eslint-disable*/
      const ratingResponse = await likeProduct({id:update.id, update:{user : connectedUser, product : update.id, content : update.reaction}}).unwrap();
      const { ids } = products;
      // getReactions({ids:JSON.stringify(ids)}).then((response) => {
      //   // Set the reactions data for each product
      //   setReactions(response.data);
      // }) .catch((error) => {});
      showAlerts({code:"success", icon:"done", title : "aimer produit",msg : ratingResponse.message, type : "toast"});
    }catch(error){
      showAlerts({code:"error", icon:"error", title : "aimer produit",msg : error.data.error, type : "toast"});
    }   
  }

  const getProducts = productsDetails => {
    filterSearch(productsDetails);
  }
  return (
    <MDBox sx={{ display: 'flex'}}>
        <CssBaseline />
        {/* <ProductSideBar filterSearch={filterSearch} open={open} setOpen={setOpen}/>
        <Divider sx={{mx: 0.5, height:'inherit'}}  orientation="vertical" /> */}
        <MDBox  component="main" sx={{ flexGrow: 1, minHeight : 200,  maxWidth:"100%"  }}>
            <DrawerHeader  my={1} p={2}>
              <Grid spacing={{xs:.5,lg:2}} alignItems="center" container>
                <Grid xs={12} md={6} lg={2} item> 
                <MDTypography variant="h4" sx={{mr:2, my :1}} >
                    Produits <MDBadge badgeContent={totalResult} color="light" variant="gradient" size="sm" max={totalResult} />
                </MDTypography>
                </Grid>
                <Grid xs={12} md={6} lg={5} item>
                <Paper
                    component="div"
                    sx={{ p: '2px', display: 'flex', alignItems: 'center',  borderRadius:2}}
                    elevation={2}
                    >
                    <MDInput size="small" name="name" value={searchTerm.name} onChange={handleSearch} type="search" placeholder="search for a product." label="Search here" fullWidth />
                    <IconButton type="button" sx={{ p: .6}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <Divider sx={{mx: 0.5, height:24, opacity:1}}  orientation="vertical" />
                    <IconButton onClick={()=>view === false && setView(true)}  type="button" sx={{ p: .6, color: view ? 'text' : "#666"  }} aria-label="search">
                      <Icon>table_rows_outlined</Icon>
                    </IconButton>
                    <Divider   sx={{mx: 0.5, height:24, opacity:1}}  orientation="vertical" />
                    <IconButton onClick={()=>view === true && setView(false)} type="button" sx={{ p: .6, color: !view ? 'text' : "#666"  }} aria-label="search">
                      <Icon>grid_view_outlined</Icon>
                    </IconButton>
                </Paper>
                </Grid>
                <Grid xs={12} lg={2} item>
                  <TopBarCategorySelect 
                      name="category"
                      selected={details?.filters.name}
                      onChange={filterSearch}
                    />
                </Grid>
                <Grid xs={3} lg={.7} item>
                  <MDDropdown textAlign="right" list={[15,25,50]} selected={searchTerm.entriesPerpage} attribute="entriesPerpage" action={filterSearch} width="fit-content"/>
                </Grid>
                <Grid xs={9} lg={1.5} item>
                  <MDDropdown textAlign="right" list={["By date ASC","By date DESC","By price ASC","By price DESC","Best selling","Near me"]} selected={searchTerm.sortBy} attribute="sortBy" action={filterSearch}/>
                </Grid>
              </Grid>  
              
            </DrawerHeader>
            <Divider/>
            {(isLoading || isFetching ) && <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
                    src={loader} alt="Avatar" variant="square" size="md" />}
            {productList && <AnimatePresence initial={false}>
                      <Grid spacing={{xs:.5,lg:2}} direction="row"  sx={{ p:{xs:.5,lg:2} }} container>
                        {productList.map( product => 
                          <MotionCard 
                            color="secondary" 
                            key={product.id} 
                            rating={<Ratings rating={product.rating} />} 
                            size={size} 
                            view={view}
                            setSelectedProduct={setSelectedProduct}
                            product={product} 
                            parseContent={parseContent}
                            cardtype={!view ? "standard" :"list"}
                            variants={variant}
                            initial="hidden"
                            animate="visible"
                            handleLikeProduct={handleLikeProduct}
                            reactLoading={reactLoading}
                            reactions={reactions?.find(item => item.product_id === product.id) ? reactions?.find(item => item.product_id === product.id).total_likes : 0}
                            likedAlready={Boolean(reactions?.find(item => item.product_id === product.id)?.users.find(item=>item.id === connectedUser?.id)) ? true : false}
                            isPartner={connectedUser?.isAdmin === "PARTNER" ? connectedUser?.id : false}
                            dist_id={Number(product.dist_id)}
                            updateProduct={updateProduct}
                            isLoading={distLoading}
                          />)}
                      </Grid>
              </AnimatePresence>}
            {productList && pageCount > 1 ? (
              <MDBox my={2} >
                <MDPagination size="medium" variant="gradient">
                  {details?.page > 0 && <MDPagination onClick={()=>getProducts({page:details?.page - 1})} item>
                      <Icon>keyboard_arrow_left</Icon>
                  </MDPagination>}
                  {[...Array(pageCount)].map((x,i) => <MDPagination key={nanoid()} item onClick={()=>getProducts({page:i})} active={details?.page === i}>{i+1}</MDPagination>)}    
                  {details?.page < pageCount -1 && <MDPagination onClick={()=>getProducts({page:details?.page + 1})} item>
                      <Icon>keyboard_arrow_right</Icon>
                  </MDPagination>}
                </MDPagination>
              </MDBox>
            ) : null}
            {(!productList && !isLoading) && <MDAlert color="info" sx={{my:3}} size="sm">{details?.filters.name !== '' || details?.filters.category !=='' ?  "aucun résultat ne correspond à votre recherche" : "La list des produits est vide"}</MDAlert>} 
        </MDBox>
        <AnimatePresence>
            {show && (
            <ProductDetails color="primary" loader={loader} product={selectedId}  setSelectedProduct={setSelectedProduct} show={show} toggleModal={toggleModal} />
          )}
        </AnimatePresence>
      </MDBox>
  )
}

export default Products